<ng-container *ngIf="hideStepper">
  <div
    role="button"
    (click)="resetStep.emit()"
    class="cursor-pointer mb-5"
  >
    <svg
      width="22"
      height="22"
      class="icon-bytesize btn-iconArrow text-primary"
    >
      <use
        stroke-width="3px"
        attr.xlink:href="{{ '#i-arrow-left' | bytesizeIcon }}"
      ></use>
    </svg>
  </div>

  <div class="text-xl font-black mb-8">{{ menuTitle }}</div>

  <ul>
    <li *ngFor="let item of menuItems">
      <a
        *ngIf="!item.children"
        [href]="item.url"
        class="block cursor-pointer py-4"
      >
        {{ item.label }}
      </a>

      <div
        *ngIf="item.children"
        (click)="changeMegaMenuMobileStep(item.label)"
        class="flex items-center cursor-pointer py-4"
      >
        <span>{{ item.label }}</span>
        <svg
          width="14"
          height="22"
          class="icon-bytesize btn-iconArrow text-primary ml-auto"
        >
          <use
            stroke-width="4px"
            attr.xlink:href="{{ '#i-chevron-right' | bytesizeIcon }}"
          ></use>
        </svg>
      </div>
    </li>
  </ul>
</ng-container>

<mat-stepper
  *ngIf="menuHasChildren?.length"
  class="stepper-megamenu"
  #megaMenuMobileStepper
>
  <ng-container *ngFor="let item of menuHasChildren">
    <mat-step *ngIf="item.children">
      <div [ngClass]="{ hidden: hideStepper }">
        <portal-ui-mega-menu-mobile
          [menuTitle]="item.label"
          [menuItems]="item.children"
          (resetStep)="resetMegaMenuMobileStep()"
        ></portal-ui-mega-menu-mobile>
      </div>
    </mat-step>
  </ng-container>
</mat-stepper>
